import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CheckIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M13.625 3.16894C13.8077 2.96197 14.124 2.94232 14.3311 3.12499C14.538 3.30771 14.5577 3.62402 14.375 3.83105L6.875 12.331C6.78369 12.4345 6.65353 12.4957 6.51562 12.5C6.37767 12.5043 6.24408 12.4511 6.14648 12.3535L1.64648 7.85351C1.45122 7.65825 1.45122 7.34174 1.64648 7.14648C1.84175 6.95122 2.15825 6.95122 2.35352 7.14648L6.47656 11.2695L13.625 3.16894Z"
      fill="currentColor"
    />
  </svg>
);
